import { AuthService } from './requests/auth/auth'
import { CitiesService } from './requests/cities/cities'
import { CountriesService } from './requests/countries/countries'
import { DocumentsService } from './requests/documents/documents'
import { DriversService } from './requests/drivers/drivers'
import { EarningsService } from './requests/earnings/earnings'
import { ProvincesService } from './requests/provinces/provinces'
import { TrainingsService } from './requests/trainings/trainings'
import { VehiclePhotosService } from './requests/vehicles/photos/vehicle-photos'

export const api = {
  auth: new AuthService(),
  cities: new CitiesService(),
  countries: new CountriesService(),
  documents: new DocumentsService(),
  drivers: new DriversService(),
  earnings: new EarningsService(),
  provinces: new ProvincesService(),
  trainings: new TrainingsService(),
  vehicles_photos: new VehiclePhotosService(),
} as const
